/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillaryManagerConfiguration,
    AncillaryManagerConfigurationFromJSON,
    AncillaryManagerConfigurationToJSON,
    AncillaryManagerListItem,
    AncillaryManagerListItemFromJSON,
    AncillaryManagerListItemToJSON,
    AncillaryManagerListQuery,
    AncillaryManagerListQueryFromJSON,
    AncillaryManagerListQueryToJSON,
} from '../models';

export interface ApiAncillaryManagerListConfigurationGetRequest {
    ancillaryCategoryId?: number;
}

export interface ApiAncillaryManagerListDataPostRequest {
    ancillaryManagerListQuery?: AncillaryManagerListQuery;
}

/**
 * no description
 */
export class AncillaryManagerListApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillaryManagerListConfigurationGetRaw(requestParameters: ApiAncillaryManagerListConfigurationGetRequest): Promise<runtime.ApiResponse<AncillaryManagerConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ancillaryCategoryId !== undefined) {
            queryParameters['ancillaryCategoryId'] = requestParameters.ancillaryCategoryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryManagerConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryManagerListConfigurationGet(requestParameters: ApiAncillaryManagerListConfigurationGetRequest): Promise<AncillaryManagerConfiguration> {
        const response = await this.apiAncillaryManagerListConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillaryManagerListDataPostRaw(requestParameters: ApiAncillaryManagerListDataPostRequest): Promise<runtime.ApiResponse<Array<AncillaryManagerListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryManagerListQueryToJSON(requestParameters.ancillaryManagerListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AncillaryManagerListItemFromJSON));
    }

    /**
     */
    async apiAncillaryManagerListDataPost(requestParameters: ApiAncillaryManagerListDataPostRequest): Promise<Array<AncillaryManagerListItem>> {
        const response = await this.apiAncillaryManagerListDataPostRaw(requestParameters);
        return await response.value();
    }

}
